export class AuthHeaderService {
    static authHeadersConfig(token: string) {
        return {
            headers: {
                "Content-type": "application/json",
                Authorization: 'Bearer ' + token,
            }
        };
    }    
}